import React from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';
import { isSkuSelectionUndefinedSelector } from 'store/selectors';
import { useAppSelector } from 'store/store';

export const IMAGE_HOST = 'https://dks.scene7.com/is/image/dkscdn';

type SwatchProps = {
  isSelected: boolean;
  isDisabled: boolean;
  onClick: (value: string) => 'color';
  color: string;
  partNumber: string;
};

function Swatch(props: Readonly<SwatchProps>) {
  const { isSelected, isDisabled, onClick, color, partNumber } = props;

  const isSkuSelectionUndefined = useAppSelector(isSkuSelectionUndefinedSelector);
  const swatch = color.replace(/[^\w]/gi, '_').replace(/(_+)\1+/g, '$1');
  return (
    <div className="hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-flex-grow-none hmf-flex-shrink quickview-swatch-container">
      <div className="quickview-outline">
        <button
          id={` ${isDisabled && 'disabled-swatch-color'}`}
          className={` hmf-position-relative ${isSelected && 'quickview-selected-swatch'} ${
            (isDisabled || (isSelected && isSkuSelectionUndefined)) && 'quickview-disabled-swatch'
          } quickview-swatch hmf-display-flex hmf-align-items-center hmf-justify-content-center`}
          key={color}
          onMouseDown={(e) => {
            e.preventDefault();
          }}
          onClick={() => onClick(color)}
          onChange={() => onClick(color)}
          onKeyDown={(e) => handleADA(e, 'button', () => onClick(color))}
          tabIndex={0}
          data-testid={`quickViewModal${swatch}`}
          type="button">
          <img
            key={color}
            id={color}
            alt={color}
            title={color}
            src={`${IMAGE_HOST}/${partNumber}_${swatch}/?hei=80&wid=80&op_sharpen=1`}
          />
        </button>
      </div>
    </div>
  );
}

export default Swatch;
